module.exports = __webpack_public_path__ + "48baa0c5de6d0ec6895c40c1bf94d633.png";